import { Route } from '@angular/router';
import { subscriptionGuard } from '@features/settings/billing/guards/subscription.guard';
import { AUDIENCE_SLUGS, CONTACTS_SLUGS, MAIN_SLUGS } from '@routes/routes.types';

export const AUDIENCE_ROUTE: Route = {
    path: MAIN_SLUGS.audience,
    loadComponent: () =>
        import('@features/audience/audience.component').then(m => m.AudienceComponent),
    canActivate: [subscriptionGuard],
    children: [
        {
            path: '',
            pathMatch: 'full',
            redirectTo: CONTACTS_SLUGS.global,
        },
        {
            path: CONTACTS_SLUGS.global,
            title: 'Global Contacts',
            loadComponent: () =>
                import('./contacts/global-contacts-page/global-contacts-page.component').then(
                    m => m.GlobalContactsPageComponent
                ),
        },
        {
            path: CONTACTS_SLUGS.table,
            title: 'Contacts overview',
            loadComponent: () =>
                import(
                    '@features/audience/contacts/contacts-table-page/contacts-table-page.component'
                ).then(m => m.ContactsTablePageComponent),
        },
        {
            path: CONTACTS_SLUGS.conversations,
            title: 'Conversations table',
            loadComponent: () =>
                import(
                    '@features/audience/conversations/conversations-table-page/conversations-table-page.component'
                ).then(m => m.ConversationsTablePageComponent),
        },
        {
            path: CONTACTS_SLUGS.calendar,
            title: 'Calendar',
            loadComponent: () =>
                import(
                    '@features/audience/contacts/contacts-calendar/contacts-calendar.component'
                ).then(m => m.ContactsCalendarComponent),
        },
        {
            path: CONTACTS_SLUGS.profile,
            title: 'Contact details',
            loadComponent: () =>
                import(
                    '@features/audience/contacts/contact-details-page/contact-details-page.component'
                ).then(m => m.ContactDetailsPageComponent),
        },
        {
            path: CONTACTS_SLUGS.bulkImporter,
            title: 'Import contacts',
            loadComponent: () =>
                import(
                    '@features/audience/contacts/contacts-bulk-importer/contacts-bulk-importer.component'
                ).then(m => m.ContactsBulkImporterComponent),
        },
        {
            path: CONTACTS_SLUGS.business,
            title: 'Business Overview',
            loadComponent: () =>
                import(
                    '@features/audience/contacts/business/business-table-page/business-table-page.component'
                ).then(m => m.BusinessTablePageComponent),
        },
        {
            path: AUDIENCE_SLUGS.pipelines,
            title: 'Pipelines',
            loadComponent: () =>
                import('@features/audience/pipeline-kanban/pipeline-kanban.component').then(
                    m => m.PipelineKanbanComponent
                ),
        },
        {
            path: AUDIENCE_SLUGS.customVariables,
            title: 'Custom Variables',
            loadComponent: () =>
                import(
                    '@features/audience/custom-variables/custom-variables-list.component'
                ).then(m => m.CustomVariablesListComponent),
        },

        {
            path: '**',
            redirectTo: CONTACTS_SLUGS.table,
        },
    ],
};
